import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Importa useLocation
import { CurpContext } from '../context/CurpContext';
import { motion } from 'framer-motion';
import EmailSuggestions from './EmailSuggestions';
import BirthDateInput from './BirthDateInput';
import CurpBuilder from './CurpBuilder';
import { toast } from 'react-hot-toast';
import Label from './form/Label';


const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 2,
        y: 0,
        transition: {
            duration: 1,
            ease: "easeInOut",
        },
    },
    exit: {
        opacity: 0,
        y: 20,
        transition: {
            duration: 1,
            ease: "easeInOut",
        },
    },
};

const SimplifiedForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isForeignInitial = location.state?.isForeign || false;
    const { curp } = useContext(CurpContext);
    console.log(curp);

    const estadosMexico = [
        { code: 'AGS', name: 'Aguascalientes' },
        { code: 'BC', name: 'Baja California' },
        { code: 'BCS', name: 'Baja California Sur' },
        { code: 'CAMP', name: 'Campeche' },
        { code: 'CHIS', name: 'Chiapas' },
        { code: 'CHIH', name: 'Chihuahua' },
        { code: 'CDMX', name: 'Ciudad de México' },
        { code: 'COAH', name: 'Coahuila' },
        { code: 'COL', name: 'Colima' },
        { code: 'DGO', name: 'Durango' },
        { code: 'GTO', name: 'Guanajuato' },
        { code: 'GRO', name: 'Guerrero' },
        { code: 'HGO', name: 'Hidalgo' },
        { code: 'JAL', name: 'Jalisco' },
        { code: 'MEX', name: 'Estado de México' },
        { code: 'MICH', name: 'Michoacán' },
        { code: 'MOR', name: 'Morelos' },
        { code: 'NAY', name: 'Nayarit' },
        { code: 'NL', name: 'Nuevo León' },
        { code: 'OAX', name: 'Oaxaca' },
        { code: 'PUE', name: 'Puebla' },
        { code: 'QRO', name: 'Querétaro' },
        { code: 'QROO', name: 'Quintana Roo' },
        { code: 'SLP', name: 'San Luis Potosí' },
        { code: 'SIN', name: 'Sinaloa' },
        { code: 'SON', name: 'Sonora' },
        { code: 'TAB', name: 'Tabasco' },
        { code: 'TAMPS', name: 'Tamaulipas' },
        { code: 'TLAX', name: 'Tlaxcala' },
        { code: 'VER', name: 'Veracruz' },
        { code: 'YUC', name: 'Yucatán' },
        { code: 'ZAC', name: 'Zacatecas' },
    ];

    const [formData, setFormData] = useState({
        consent_to_share_data: null,
        consent_for_follow_up: null,
        name: '',
        surnames: '',
        nickname: '',
        foreign: isForeignInitial,
        curp: isForeignInitial ? '' : curp,
        email: '',
        phone_number: '',
        healthcare_status: '',
        state: '',
        city: '',
        date_birth: '',
        gender_identity: '',
        sexual_orientation: '',
        is_sex_worker: null,
        sex_affective_partners: [],
        substance_use: '',
        sex_with_substance_user: ''
    });


    const isFormValid = () => {
        const requiredFields = [
            'name',
            'surnames',
            'nickname',
            'email',
            'phone_number',
            'healthcare_status',
            'state',
            'city',
            'date_birth',
            'gender_identity',
            'sexual_orientation',
            'is_sex_worker',
            'substance_use',
            'sex_with_substance_user'
        ];
        return requiredFields.every(field => {
            const value = formData[field];
            return value !== null && value !== '' && value !== undefined;
        });
    }
    console.log(isFormValid());

    const onClickB = (e) => {
        e.preventDefault(); // Prevenir que se envíe el formulario por accidente

        if (!isFormValid()) {
            toast.error('Por favor, completa todos los campos obligatorios');
            return;
        }

        // Si es válido, puedes llamar a handleSubmit manualmente si lo necesitas
        handleSubmit(e);
    };


    const sexAffectivePartnersList = [
        'Mujeres', 'Hombres', 'Mujeres y hombres', 'Mujeres trans', 'Hombres trans', 'Personas no binarias',
    ];

    const inputClass = "border p-2 rounded-xl w-full drop-shadow-sm mt-1 bg-white/50 focus:bg-white focus:ring-2 focus:ring-[#f8485e]/20 outline-none transition-all text-gray-700 font-medium";
    const textClass = "text-base font-semibold mt-16 mb-8 text-justify text-gray-800 block";
    const textClass2 = "mt-2 lg:mt-8 mb-1 font-bold text-left text-gray-700";
    const labelClass = "block text-gray-600 font-bold uppercase text-[10px] tracking-wider mb-1 ml-1";
    const litteTextClass = "text-xs text-left text-gray-400 font-medium uppercase tracking-wider";
    const buttonsContainer = "flex w-full space-x-4 mt-5";



    if (!curp && !formData.foreign) {
        toast.error('El CURP no está disponible. Redirigiendo...');
        setTimeout(() => navigate('/rapido'), 3000);
        return null;
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : (value === '' ? null : value) });
    };

    const handleEmailSelect = (fullEmail) => {
        setFormData({ ...formData, email: fullEmail });
    };

    const handleButtonClick = (name, value) => {
        setFormData({ ...formData, [name]: value });
    };

    const handleButtonClick2 = (field, value) => {
        setFormData((prevData) => {
            const currentValues = prevData[field] || [];

            // Si ya está seleccionado, lo quitamos
            if (currentValues.includes(value)) {
                return {
                    ...prevData,
                    [field]: currentValues.filter((item) => item !== value),
                };
            }

            // Si no está, lo agregamos
            return {
                ...prevData,
                [field]: [...currentValues, value],
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Datos del formulario
        const userData = { ...formData, curp: curp };

        toast.promise(
            fetch('https://admin-django-inspira.azurewebsites.net/api/users/simplified-register/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(userData),
            })
                .then(response => {
                    if (!response.ok) throw new Error('Error en el registro');
                    return response.json();
                })
                .then(data => {
                    // Sin evento activo el backend no devuelve event_id: mandamos a
                    // /thank-you en vez de generar un QR que codifique "undefined".
                    if (!data.event_id) {
                        navigate('/thank-you');
                        return 'Tu registro se guardó, pero no hay un evento activo para generar tu código.';
                    }
                    const ref = data.curp_ref ? `?ref=${data.curp_ref}` : '';
                    navigate(`/test/simplified/qrdisplay/${data.event_id}${ref}`);
                    return '¡Listo! Aquí está tu código.';
                }),
            {
                loading: 'Lxs gatitxs están organizando tu información... porque, obviamente, son súper organizadxs. 🐱📁', // Mensaje de carga
                success: (message) => message, // Mensaje de éxito
                error: (err) => `Error: ${err.message}`, // Mensaje de error
            }
        );
    };

    return (
        <>
            {formData.foreign && <CurpBuilder formData={formData} />}
            <motion.div
                className="w-full text-left mt-0 lg:w-1/3 lg:mb-10"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.h1 initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }} className='text-left text-5xl font-black text-[#f8485e] mt-10 mb-8 leading-tight drop-shadow-sm'>Es hora de la fiesta de preguntas 🎉</motion.h1>
                <motion.h1 variants={itemVariants} className="text-base text-justify font-medium mt-5 mb-5 text-gray-700 leading-relaxed">Tu información es confidencial y está protegida. Responde con sinceridad para darte una mejor atención. 🫡</motion.h1>
                <motion.hr className="w-full border-t border-gray-300 my-4" variants={itemVariants} />
                <form onSubmit={handleSubmit} className="p-0">
                    <motion.div variants={containerVariants} className="mb-4">
                        <label className={textClass}>Autorizo que, si mi resultado es reactivo, mis datos se compartan con el Centro para la Prevención y Atención Integral del VIH Sida de la CDMX, conforme a la Ley de Protección de Datos Personales. 🔒</label>
                        <div className={buttonsContainer}>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('consent_to_share_data', true)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${formData.consent_to_share_data ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    Acepto
                                </button>
                            </motion.div>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('consent_to_share_data', false)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${formData.consent_to_share_data === false ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    No acepto
                                </button>
                            </motion.div>
                        </div>
                    </motion.div>
                    <motion.div variants={containerVariants} className="mb-16">
                        <label className={textClass}>Si mi resultado es reactivo o positivo, doy mi consentimiento para que Inspira me acompañe en el acceso a salud y tratamiento.</label>
                        <div className={buttonsContainer}>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('consent_for_follow_up', true)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${formData.consent_for_follow_up ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    Acepto
                                </button>
                            </motion.div>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('consent_for_follow_up', false)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${formData.consent_for_follow_up === false ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    No acepto
                                </button>
                            </motion.div>
                        </div>
                    </motion.div>
                    <div className="mb-4">
                        <label className="block text-gray-800 font-bold uppercase text-xs">Correo</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={inputClass}
                            required
                        />
                        <EmailSuggestions email={formData.email} onSelect={handleEmailSelect} />
                    </div>
                    <div className='flex space-x-4 mb-6 w-full justify-center'>
                        <label className="flex items-center gap-3 text-gray-700 font-bold cursor-pointer my-1">
                            <motion.input
                                type="checkbox"
                                name="foreign"
                                checked={formData.foreign}
                                onChange={handleChange}
                                whileHover={{ scale: 1.1 }}
                                whileTap={{ scale: 0.95 }}
                                className="h-5 w-5 accent-[#f8485e] rounded-lg border-gray-300 focus:ring-2 focus:ring-[#f8485e]/20 shadow-sm"
                            />
                            <span className="text-sm uppercase tracking-wide">Soy extranjero</span>
                        </label>
                    </div>
                    <div className="flex space-x-4 mb-4">
                        <div className='w-1/2'>
                            <label className="block text-gray-800 font-bold uppercase text-xs">Nombres</label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                        </div>
                        <div className='w-1/2'>
                            <label className="block text-gray-800 font-bold uppercase text-xs">Apellidos</label>
                            <input
                                type="text"
                                name="surnames"
                                value={formData.surnames}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                        </div>
                    </div>
                    <motion.div
                        initial={{ x: -100 }}
                        animate={{ x: 0 }}
                        transition={{ duration: 1 }}
                        className='w-full text-left mt-5 lg:w-3/3 lg:mb-10 bg-inspiraPurple rounded-3xl p-4 pt-1 drop-shadow-xl mb-5'>
                        <h1 className="text-lg font-bold mt-2 mb-5 text-justify text-white drop-shadow-md uppercase">¿Cómo te gusta que te llamen? Este será el nombre que usaremos contigo. 😇</h1>
                        <div className="mb-4">
                            <label className="block text-white font-bold uppercase text-xs">Nombre elegido ✨</label>
                            <input
                                type="text"
                                name="nickname"
                                value={formData.nickname}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            />
                        </div>
                    </motion.div>
                    <div className="mb-5">
                        <label className={labelClass}>Número telefónico 📱</label>
                        <input type="number"
                            name="phone_number"
                            value={formData.phone_number}
                            onChange={handleChange}
                            required
                            className={inputClass}
                        ></input>
                    </div>
                    <div className="mb-8">
                        <label className={labelClass}>Fecha de Nacimiento</label>
                        <BirthDateInput 
                            value={formData.date_birth} 
                            onChange={(val) => setFormData({ ...formData, date_birth: val })} 
                            required 
                        />
                    </div>
                    <div className='flex space-x-4 mb-4'>
                        <div className="w-1/2">
                            <Label text="Ciudad / Alcaldía" className="text-gray-800 font-bold uppercase text-xs" />
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                className={inputClass}
                            />
                        </div>
                        <div className="w-1/2">
                            <Label text="Estado" className="text-gray-800 font-bold uppercase text-xs" />
                            <select
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            >
                                <option value="">Selecciona un estado</option>
                                {estadosMexico.map((estado) => (
                                    <option key={estado.code} value={estado.code}>
                                        {estado.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='flex space-x-4 mb-4'>
                        <div className="w-1/2">
                            {/* <label className={labelClass}>Seguridad Social</label> */}
                            <Label text="Seguridad Social" className="text-gray-800 font-bold uppercase text-xs" />
                            <select
                                name="healthcare_status"
                                value={formData.healthcare_status}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            >
                                <option value="">Seleccione una opción</option>
                                <option value="0">IMSS</option>
                                <option value="1">ISSSTE</option>
                                <option value="2">INSABI (Seguro Popular)</option>
                                <option value="3">PEMEX</option>
                                <option value="4">Carrera técnica</option>
                                <option value="5">ISSFAM</option>
                                <option value="6">Seguro privado o seguro de gastos médicos mayores</option>
                                <option value="7">Sin seguro</option>
                            </select>
                        </div>
                        <div className="w-1/2">
                            <label className="block text-gray-800 font-bold uppercase text-xs">Identidad de Género</label>
                            <select
                                name="gender_identity"
                                value={formData.gender_identity}
                                onChange={handleChange}
                                className={inputClass}
                            >
                                <option value="">Seleccione su identidad de género</option>
                                <option value="0">Mujer trans</option>
                                <option value="1">Hombre trans</option>
                                <option value="2">Persona no binaria</option>
                                <option value="3">Mujer</option>
                                <option value="4">Hombre</option>
                            </select>
                        </div>
                    </div>
                    <div className='flex space-x-4 mb-4'>
                        <div className="w-full">
                            <label className="block text-gray-800 font-bold uppercase text-xs">Orientación Sexual</label>
                            <select
                                name="sexual_orientation"
                                value={formData.sexual_orientation}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            >
                                <option value="">Seleccione</option>
                                <option value="0">Gay</option>
                                <option value="1">Lesbiana</option>
                                <option value="2">Bisexual</option>
                                <option value="3">Heterosexual</option>
                                <option value="4">Asexual</option>
                                <option value="5">Demisexual</option>
                                <option value="6">Pansexual</option>
                            </select>
                        </div>
                    </div>
                    <motion.div variants={containerVariants} className="mb-4">
                        <label className={textClass}>¿Actualmente ejerces trabajo sexual?</label>
                        <div className={buttonsContainer}>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('is_sex_worker', true)}
                                    className={`rounded-md drop-shadow-md p-2 m-2 w-full ${formData.is_sex_worker ? 'bg-inspiraPink text-white' : 'bg-white text-inspiraPink'}`}
                                >
                                    Sí
                                </button>
                            </motion.div>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('is_sex_worker', false)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-center font-bold uppercase transition-all ${formData.is_sex_worker === false ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    No
                                </button>
                            </motion.div>
                        </div>
                    </motion.div>
                    <div className="mt-4 mx-auto flex flex-col ">
                        <label className={textClass2}>¿Con quiénes te relacionas sexoafectivamente de forma habitual?</label>
                        <label className={litteTextClass}>(Puedes seleccionar más de una opción)</label>
                        <motion.div variants={containerVariants} className="grid grid-cols-3 gap-3 p-1 mt-5 place-items-stretch">
                            {sexAffectivePartnersList.map((choice) => (
                                <motion.button
                                    variants={itemVariants}
                                    key={choice}
                                    type="button"
                                    onClick={() => handleButtonClick2('sex_affective_partners', choice)}
                                    className={`w-28 h-20 px-2 flex flex-col rounded-xl border-2 shadow-sm items-center justify-center text-center text-[10px] sm:text-xs font-bold uppercase transition-all active:scale-95 ${formData.sex_affective_partners.includes(choice)
                                        ? 'bg-inspiraPink text-white border-inspiraPink'
                                        : 'bg-white text-inspiraPink border-inspiraPink'
                                        }`}
                                >
                                    {choice}
                                </motion.button>
                            ))}
                        </motion.div>
                    </div>
                    <motion.div className="mb-4" variants={itemVariants}>
                        <motion.h1 initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 1, delay: 0.5 }} className='text-center text-7xl font-bold text-white mt-10 mb-10 drop-shadow-sm'>😛</motion.h1>
                        <label className={textClass}>¿Consumes algún tipo de sustancia ya sea fumada, inhalada, tomada, inyectada, etc.? Recuerda que la información que nos compartes es confidencial, está protegida y a nuestro equipo de consejería le sirve para brindarte un mejor servicio en reducción de riesgos y mitigación de daños</label>
                        <select
                            name="substance_use"
                            value={formData.substance_use}
                            onChange={handleChange}
                            className={inputClass}
                            required
                        >
                            <option value="">Selecciona</option>
                            <option value="Si">Sí</option>
                            <option value="No">No</option>
                            <option value="Ocasional">Ocasionalmente</option>
                            <option value="Prefiero no responder">Prefiero no responder</option>
                        </select>
                    </motion.div>
                    <motion.div className="mb-4" variants={itemVariants}>
                        <label className={textClass}>¿En el último mes tuviste relaciones sexuales con alguna persona que se encontraba bajo el efecto de alguna sustancia?</label>
                        <select
                            name="sex_with_substance_user"
                            value={formData.sex_with_substance_user}
                            onChange={handleChange}
                            className={inputClass}
                            required
                        >
                            <option value="">Selecciona</option>
                            <option value="Si">Sí</option>
                            <option value="No">No</option>
                            <option value="No sabe">No lo sé</option>
                        </select>
                    </motion.div>
                    <motion.div variants={itemVariants} className='w-full flex justify-center'>
                        <button
                            type="submit"
                            className="bg-[#f8485e] hover:bg-[#d93a4f] text-white mt-10 mb-24 p-4 rounded-xl shadow-lg w-1/2 text-lg font-bold uppercase transition-all active:scale-95 disabled:opacity-50"
                            disabled={!isFormValid()}
                            onClick={onClickB}
                        >
                            Enviar ✨
                        </button>
                    </motion.div>
                </form>
            </motion.div>
        </>
    );
};

export default SimplifiedForm;